export default function getBase64(file) {
  var reader = new FileReader();
  return new Promise((resolve, reject) => {
      reader.onerror = () => { reader.abort(); reject(new Error("Error parsing file"));}
      reader.onload = function () {

          //This will result in an array that will be recognized by C#.NET WebApi as a byte[]
          let bytes = Array.from(new Uint8Array(this.result));

          //if you want the base64encoded file you would use the below line:
          let base64String = btoa(bytes.map((item) => String.fromCharCode(item)).join(""));

          //Resolve the promise with your custom file structure
          resolve(base64String);
      }
      reader.readAsArrayBuffer(file);
  });
}

